import React, { useState, useEffect } from "react";
import moment from "moment";
import { IoIosClose } from "react-icons/io";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { baseUrl } from "../../Environments/environment.js";

const customStyles = {
  "--react-datepicker-time-list-bg": "white",
};

const HouseKeepingRequestAddOn = ({
  houseKeeping,
  isModalOpen,
  setIsModalOpen,
  handleSendRequest,
  handleOptionChange,
  selectedOptions,
}) => {
  return (
    <div
      className={`fixed bottom-0 left-0 w-full bg-white p-4 shadow-lg transition-transform transform ${
        isModalOpen ? "translate-y-0" : "translate-y-full"
      } h-80 flex flex-col`}
      style={{ zIndex: 9999 }}
    >
      {/* Header Section */}
      <div className="flex items-center justify-between pb-4 text-black">
        <div className="text-lg font-semibold text-black">
          Add-ons in Housekeeping
        </div>
        <button
          onClick={(e) => {
            e.preventDefault();
            setIsModalOpen(false);
          }}
        >
          <IoIosClose className="h-8 w-8 text-black" />
        </button>
      </div>

      {/* Scrollable Add-ons Section */}
      <div className="flex-1 overflow-y-auto text-black">
        {houseKeeping.options.length > 0 ? (
          <div className="grid grid-cols-2 gap-4">
            {houseKeeping.options.map((addon, index) => (
              <label key={index} className="flex items-center space-x-2">
                <input
                  type="checkbox"
                  className=""
                  onChange={handleOptionChange}
                  name="options"
                  value={addon}
                  checked={selectedOptions.includes(addon)}
                />
                <span>{addon}</span>
              </label>
            ))}
          </div>
        ) : (
          <div className="text-black">No addons available</div>
        )}
      </div>

      {/* Fixed Bottom Button */}
      <div className="mt-2">
        <button
          className="w-full py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50"
          onClick={(e) => {
            e.preventDefault();
            handleSendRequest();
            setIsModalOpen(false);
          }}
        >
          Send Request
        </button>
      </div>
    </div>
  );
};

export default HouseKeepingRequestAddOn;
